// Famous sports players database for Mystery Player Challenge
const FAMOUS_PLAYERS = [
  { name: 'Sachin Tendulkar', sport: 'Cricket', searchTerm: 'Sachin Tendulkar' },
  { name: 'Virat Kohli', sport: 'Cricket', searchTerm: 'Virat Kohli' },
  { name: 'MS Dhoni', sport: 'Cricket', searchTerm: 'MS Dhoni' },
  { name: 'Ricky Ponting', sport: 'Cricket', searchTerm: 'Ricky Ponting' },
  { name: 'Brian Lara', sport: 'Cricket', searchTerm: 'Brian Lara' },
  { name: 'Shane Warne', sport: 'Cricket', searchTerm: 'Shane Warne' },
  { name: 'Jacques Kallis', sport: 'Cricket', searchTerm: 'Jacques Kallis' },
  { name: 'Kumar Sangakkara', sport: 'Cricket', searchTerm: 'Kumar Sangakkara' },
  { name: 'AB de Villiers', sport: 'Cricket', searchTerm: 'AB de Villiers' },
  { name: 'Wasim Akram', sport: 'Cricket', searchTerm: 'Wasim Akram' },
  { name: 'Imran Khan', sport: 'Cricket', searchTerm: 'Imran Khan (cricketer)' },
  { name: 'Kapil Dev', sport: 'Cricket', searchTerm: 'Kapil Dev' },
  { name: 'Rahul Dravid', sport: 'Cricket', searchTerm: 'Rahul Dravid' },
  { name: 'Rohit Sharma', sport: 'Cricket', searchTerm: 'Rohit Sharma' },
  { name: 'Jasprit Bumrah', sport: 'Cricket', searchTerm: 'Jasprit Bumrah' },
  
  // Football
  { name: 'Lionel Messi', sport: 'Football', searchTerm: 'Lionel Messi' },
  { name: 'Cristiano Ronaldo', sport: 'Football', searchTerm: 'Cristiano Ronaldo' },
  { name: 'Neymar', sport: 'Football', searchTerm: 'Neymar' },
  { name: 'Kylian Mbappé', sport: 'Football', searchTerm: 'Kylian Mbappé' },
  { name: 'Diego Maradona', sport: 'Football', searchTerm: 'Diego Maradona' },
  { name: 'Pelé', sport: 'Football', searchTerm: 'Pelé' },
  { name: 'Zinedine Zidane', sport: 'Football', searchTerm: 'Zinedine Zidane' },
  { name: 'Ronaldinho', sport: 'Football', searchTerm: 'Ronaldinho' },
  { name: 'David Beckham', sport: 'Football', searchTerm: 'David Beckham' },
  { name: 'Thierry Henry', sport: 'Football', searchTerm: 'Thierry Henry' },
  { name: 'Zlatan Ibrahimović', sport: 'Football', searchTerm: 'Zlatan Ibrahimović' },
  { name: 'Robert Lewandowski', sport: 'Football', searchTerm: 'Robert Lewandowski' },
  { name: 'Erling Haaland', sport: 'Football', searchTerm: 'Erling Haaland' },
  { name: 'Mohamed Salah', sport: 'Football', searchTerm: 'Mohamed Salah' },
  { name: 'Kevin De Bruyne', sport: 'Football', searchTerm: 'Kevin De Bruyne' },
  
  // Basketball
  { name: 'Michael Jordan', sport: 'Basketball', searchTerm: 'Michael Jordan' },
  { name: 'LeBron James', sport: 'Basketball', searchTerm: 'LeBron James' },
  { name: 'Kobe Bryant', sport: 'Basketball', searchTerm: 'Kobe Bryant' },
  { name: 'Stephen Curry', sport: 'Basketball', searchTerm: 'Stephen Curry' },
  { name: 'Kevin Durant', sport: 'Basketball', searchTerm: 'Kevin Durant' },
  { name: 'Shaquille O\'Neal', sport: 'Basketball', searchTerm: 'Shaquille O\'Neal' },
  { name: 'Magic Johnson', sport: 'Basketball', searchTerm: 'Magic Johnson' },
  { name: 'Larry Bird', sport: 'Basketball', searchTerm: 'Larry Bird' },
  { name: 'Tim Duncan', sport: 'Basketball', searchTerm: 'Tim Duncan' },
  { name: 'Giannis Antetokounmpo', sport: 'Basketball', searchTerm: 'Giannis Antetokounmpo' },
  
  // Tennis
  { name: 'Roger Federer', sport: 'Tennis', searchTerm: 'Roger Federer' },
  { name: 'Rafael Nadal', sport: 'Tennis', searchTerm: 'Rafael Nadal' },
  { name: 'Novak Djokovic', sport: 'Tennis', searchTerm: 'Novak Djokovic' },
  { name: 'Serena Williams', sport: 'Tennis', searchTerm: 'Serena Williams' },
  { name: 'Venus Williams', sport: 'Tennis', searchTerm: 'Venus Williams' },
  { name: 'Pete Sampras', sport: 'Tennis', searchTerm: 'Pete Sampras' },
  { name: 'Andre Agassi', sport: 'Tennis', searchTerm: 'Andre Agassi' },
  { name: 'Maria Sharapova', sport: 'Tennis', searchTerm: 'Maria Sharapova' },
  { name: 'Naomi Osaka', sport: 'Tennis', searchTerm: 'Naomi Osaka' },
  { name: 'Carlos Alcaraz', sport: 'Tennis', searchTerm: 'Carlos Alcaraz' },
  
  // Boxing/MMA
  { name: 'Muhammad Ali', sport: 'Boxing', searchTerm: 'Muhammad Ali' },
  { name: 'Mike Tyson', sport: 'Boxing', searchTerm: 'Mike Tyson' },
  { name: 'Floyd Mayweather Jr.', sport: 'Boxing', searchTerm: 'Floyd Mayweather Jr.' },
  { name: 'Manny Pacquiao', sport: 'Boxing', searchTerm: 'Manny Pacquiao' },
  { name: 'Conor McGregor', sport: 'MMA', searchTerm: 'Conor McGregor' },
  
  // Golf
  { name: 'Tiger Woods', sport: 'Golf', searchTerm: 'Tiger Woods' },
  { name: 'Jack Nicklaus', sport: 'Golf', searchTerm: 'Jack Nicklaus' },
  { name: 'Arnold Palmer', sport: 'Golf', searchTerm: 'Arnold Palmer' },
  { name: 'Rory McIlroy', sport: 'Golf', searchTerm: 'Rory McIlroy' },
  
  // Swimming/Athletics
  { name: 'Usain Bolt', sport: 'Athletics', searchTerm: 'Usain Bolt' },
  { name: 'Michael Phelps', sport: 'Swimming', searchTerm: 'Michael Phelps' },
  { name: 'Carl Lewis', sport: 'Athletics', searchTerm: 'Carl Lewis' },
  { name: 'Jesse Owens', sport: 'Athletics', searchTerm: 'Jesse Owens' },
  
  // Hockey
  { name: 'Wayne Gretzky', sport: 'Ice Hockey', searchTerm: 'Wayne Gretzky' },
  { name: 'Sidney Crosby', sport: 'Ice Hockey', searchTerm: 'Sidney Crosby' },
  
  // Baseball
  { name: 'Babe Ruth', sport: 'Baseball', searchTerm: 'Babe Ruth' },
  { name: 'Jackie Robinson', sport: 'Baseball', searchTerm: 'Jackie Robinson' },
  
  // F1
  { name: 'Ayrton Senna', sport: 'Formula 1', searchTerm: 'Ayrton Senna' },
  { name: 'Michael Schumacher', sport: 'Formula 1', searchTerm: 'Michael Schumacher' },
  { name: 'Lewis Hamilton', sport: 'Formula 1', searchTerm: 'Lewis Hamilton' },
  { name: 'Max Verstappen', sport: 'Formula 1', searchTerm: 'Max Verstappen' },
];

export default FAMOUS_PLAYERS;
